import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { Card } from 'primereact/card'
import { InputSwitch } from 'primereact/inputswitch'

import { PanelContainer } from '../../../../../components/Panel'
import { usePanelContext } from '../../../../../contexts'
import { FormFieldName, FormValues } from './general-data'

type Props = {
  formik: FormikProps<FormValues>
  isRequestRunning: boolean
}

export const GeneralView: React.FC<Props> = ({ formik, isRequestRunning }) => {
  const { t } = useTranslation('buyerSettings')
  const { isEdit } = usePanelContext()

  const panelId = 'settings-general'

  const isFormFieldInvalid = (name: FormFieldName) => !!formik.errors[name]

  const getFormErrorMessage = (name: FormFieldName) => {
    return isFormFieldInvalid(name) ? (
      <small className="p-error">{formik.errors[name]}</small>
    ) : null
  }

  return (
    <PanelContainer
      header={t('general.title')}
      formik={formik}
      id={panelId}
      toggleable={false}
      isRequestRunning={isRequestRunning}
    >
      <div className="grid">
        {/* Global functions */}
        <div className="col-12 lg:col-4">
          <h3 className="m-0">{t('general.globalFunctions.title')}</h3>
          <p>{t('general.globalFunctions.description')}</p>
        </div>
        <div className="col-12 lg:col-7 lg:col-offset-1">
          <Card className="md:px-4">
            {/* Virus check */}
            <div className="flex flex-column md:flex-row flex-wrap md:align-items-center justify-content-between gap-4">
              <div className="flex flex-row align-items-center gap-4">
                <InputSwitch
                  id="isMalwareScanningActive"
                  className="flex-shrink-0"
                  checked={formik.values.isMalwareScanningActive}
                  onChange={formik.handleChange}
                  disabled={!isEdit(panelId)}
                />
                <div>
                  <label
                    className="font-bold text-lg"
                    htmlFor="isMalwareScanningActive"
                  >
                    {t('general.globalFunctions.form.malwareScanning.title')}
                  </label>
                  <p className="mt-2">
                    {t(
                      'general.globalFunctions.form.malwareScanning.description',
                    )}
                  </p>
                </div>
                {getFormErrorMessage('isMalwareScanningActive')}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </PanelContainer>
  )
}
